import { CouponAction, CouponLogStatus, CouponSystem } from "./Enums";

export class CouponLogsFilter {
  reference: number | null = null;
  keywords = '';
  orderBy = 'Id';
  asc = false;
  
  status: CouponLogStatus | null = null;
  createdDateFrom: string | null = null;
  createdDateTo: string | null = null;
  providerId: number | null = null;
  externalSystem: CouponSystem | null = null;
}

export interface CouponLog {
  id: string;
  externalSystemType: CouponSystem;
  status: CouponLogStatus;
  createdAt: string;
  providerId: string;
  responseData: string;
  requestData: string;
  action: CouponAction;
  couponCode: string;
  orderNumber: number | null;
}